export interface RetryOptions {
  readonly attempts?: number;
  readonly backoffMs?: number;
  readonly wait?: (milliseconds: number) => Promise<void>;
}

function wait(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, milliseconds);
  });
}

/**
 * Retries a bounded number of transient browser requests. The final failure is
 * preserved for the caller's visible recovery state rather than being hidden.
 */
export async function requestWithRetry<T>(
  request: () => Promise<T>,
  { attempts = 2, backoffMs = 250, wait: pause = wait }: RetryOptions = {},
): Promise<T> {
  let lastError: unknown;
  for (let attempt = 1; attempt <= attempts; attempt += 1) {
    try {
      return await request();
    } catch (error) {
      lastError = error;
      if (attempt < attempts) await pause(backoffMs * attempt);
    }
  }
  throw lastError;
}
